export default "//cdn.scentbird.com/assets/frontbird-site/images/oranges_e33ba3.jpg";